import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { Locations, ProductLine, NavigationEvents } from '@mc/track-event'
import Link from 'components/Link'
import {
  useFlw1235EnterpriseNavCta,
  useFlw1235IsDesktopViewport,
} from 'experiments/flw-1235_v2_enterprise_nav_cta'
import { trackNavigationClick } from '../events'

export const AtWorkLink = ({
  className = '',
  location = Locations.NAVIGATION,
  product = ProductLine.AT_WORK,
}: {
  className?: string
  location?: (typeof Locations)[keyof typeof Locations]
  product?: (typeof ProductLine)[keyof typeof ProductLine]
}) => {
  const { t } = useTranslation('@mc/next')

  // Every caller hides this link below `lg` (`d-none d-lg-block`, either here
  // or on the `TopNavigation` shell) without unmounting it, so exposure is
  // gated on the breakpoint. Strict `=== true`: the viewport is `undefined`
  // until measured, and an unmeasured viewport must not count as exposed.
  const isDesktop = useFlw1235IsDesktopViewport()
  const ctaCopy = useFlw1235EnterpriseNavCta(
    t('nav.cta.work'),
    isDesktop === true,
  )

  const handleAtWorkClick = () => {
    trackNavigationClick(
      ctaCopy,
      NavigationEvents.LEVELS.PRIMARY,
      location,
      product,
    )
  }

  return (
    <Link
      href={paths.enterpriseHomepage}
      className={`mc-ml-4 ${className}`}
      onClick={handleAtWorkClick}
      passHref
      newTab
      isBasic
    >
      {ctaCopy}
    </Link>
  )
}
